import { render } from "./ProdutosDescricao.vue?vue&type=template&id=4db2ab46&scoped=true"
import script from "./ProdutosDescricao.vue?vue&type=script&lang=js"
export * from "./ProdutosDescricao.vue?vue&type=script&lang=js"

import "./ProdutosDescricao.vue?vue&type=style&index=0&id=4db2ab46&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src130918171/src/app-heineken/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4db2ab46"]])

export default __exports__